import { firstWorkStep, workStepsFor, type MeResponse, type SessionKind, type WorkStep } from "@studio/shared";

/**
 * 다시 들어온 학생이 갈 단계(Codex 검수 2026-10-13 P0-3).
 * 저장된 단계가 이 작품·이 수업의 것이 아니면 첫 단계 — 새 학생과 같다.
 */
export function chooseResumeStep(
  me: Pick<MeResponse, "work_id" | "step"> & { active_job?: MeResponse["active_job"] } | null,
  workId: string,
  kind: SessionKind,
): WorkStep {
  if (!me || me.work_id !== workId) return firstWorkStep(kind);
  // 🔑 곡이 만들어지는 중이면 단계 저장이 실패했어도 결과 화면으로 — 거기서 진행을 본다.
  if (kind === "music" && me.active_job) return "result";
  if (workStepsFor(kind).includes(me.step)) return me.step;
  return firstWorkStep(kind);
}
